import { Component, OnInit } from '@angular/core';
import { PrimeNGConfig } from 'primeng/api';
import { AuthService } from './shared/services/auth.service';
import { AppConfig, LayoutService } from './layout/service/app.layout.service';
import { APP_VERSION, BUILD_DATE } from '../environments/version';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {

    private currentVersion: string;
    version: string;

    constructor(private primengConfig: PrimeNGConfig,
        private authService: AuthService,
        private layoutService: LayoutService) { }

    ngOnInit() {
        console.log(`Mindconnect UI v${APP_VERSION} (built ${BUILD_DATE})`);

        this.primengConfig.ripple = true;

        const config: AppConfig = {
            ripple: true, //toggles ripple on and off
            inputStyle: 'outlined', //default style for input elements
            menuMode: 'static', //layout mode of the menu, valid values are "static", "overlay", "slim", "horizontal", "reveal" and "drawer"
            colorScheme: 'light', //color scheme of the template, valid values are "light", "dim" and "dark"
            theme: 'lara-light-purple', //default component theme for PrimeNG
            scale: 16, //size of the body font size to scale the whole application
        };

        this.layoutService.config.set(config);

        this.currentVersion = localStorage.getItem('version')!;

        // Local builds keep the 'dev' placeholder (UAT builds are not production-mode, so
        // environment.production can't tell them apart) — nothing to detect, so skip the poll.
        // Widened to string: version.ts exports a literal type, which CI re-stamps to the build number.
        const appVersion: string = APP_VERSION;

        if (appVersion !== 'dev') {
            this.setVersion();

            setInterval(() => this.setVersion(), 30000);
        }

        this.authService.autoLogin();
    }

    // [AUTH-58] A fresh visit (no stored version) ADOPTS the current version instead of forcing a
    // reload, and `currentVersion` is updated in memory before reloading — so an unavailable
    // localStorage can no longer cause a reload-every-30s loop. (logout() also no longer clears
    // the 'version' key.)
    setVersion() {
        // Native fetch, not HttpClient: the request must skip the auth/error interceptors so a
        // transient failure mid-deploy shows no error toast and carries no Bearer token. The
        // cache-buster + no-store keep IIS/browser caches from delaying update detection.
        fetch(`/assets/config.json?t=${Date.now()}`, { cache: 'no-store' })
            .then(response => response.ok ? response.json() : null)
            .then((data: any) => {
                if (!data?.version) {
                    return;
                }

                this.version = data.version;

                if (!this.currentVersion) {
                    this.currentVersion = this.version;
                    localStorage.setItem('version', this.version);
                    return;
                }

                if (this.currentVersion !== this.version) {
                    this.currentVersion = this.version;
                    localStorage.setItem('version', this.version);
                    console.log(`New version ${this.version} deployed — reloading`);
                    window.location.reload();
                }
            })
            .catch(() => { /* transient failure — the next poll retries */ });
    }
}
